module.exports = "<div class=\"form-group\">\n    <label class=\"control-label m-b\">\n        {{ element.label }}\n        <span ng-if=\"element.required\"\n              class=\"text-danger\"\n        >\n            *\n        </span>\n    </label>\n\n    <document-upload directory-id=\"element.value.value\"\n                     document-id=\"element.responseValue\"\n    />\n\n    <p class=\"m-t\"\n       ng-if=\"element.description\"\n       ng-bind-html=\"element.description | nl2br\"\n    ></p>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/js/directives/formElements/inputDocumentUpload/view.html
// module id = 936
// module chunks = 0